// Like RBS package, we will have some courses that have special requirements.
const BASSET_ID = 5310;
const CA_RBS_ID = 5300;
const SAN_DIEGO_FOOD_HANDLER_ID = 5260;
const TEXAS_FOOD_HANDLER_ID = 5130;
const UTAH_FOOD_HANDLER_ID = 5270;

/** Course require Date of Birth of user. */
export const COURSES_REQUIRED_DOB = [BASSET_ID, CA_RBS_ID, SAN_DIEGO_FOOD_HANDLER_ID, TEXAS_FOOD_HANDLER_ID, UTAH_FOOD_HANDLER_ID];

export const STATUS_APPROVED = 4020;
export const STATUS_COMPLETED_PASS = 4072;
export const STATUS_COMPLETED_FAIL = 4074;
